import { render, staticRenderFns } from "./SchoolCounselingConfigList.vue?vue&type=template&id=3cd66fa8&scoped=true"
import script from "./SchoolCounselingConfigList.vue?vue&type=script&lang=js"
export * from "./SchoolCounselingConfigList.vue?vue&type=script&lang=js"
import style0 from "./SchoolCounselingConfigList.vue?vue&type=style&index=0&id=3cd66fa8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd66fa8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cd66fa8')) {
      api.createRecord('3cd66fa8', component.options)
    } else {
      api.reload('3cd66fa8', component.options)
    }
    module.hot.accept("./SchoolCounselingConfigList.vue?vue&type=template&id=3cd66fa8&scoped=true", function () {
      api.rerender('3cd66fa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/schoolCounselingConfig/SchoolCounselingConfigList.vue"
export default component.exports